import exec from './exec';
import firmwareupgrade from './firmwareupgrade';
import reboot from './reboot';

export default { exec, firmwareupgrade, reboot };
